import type { ModalProps } from '@mantine/core';
import { Modal } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const FormModal = (props: ModalProps) => {
  const isMobile = useMediaQuery('(max-width: 48em)', undefined, {
    getInitialValueInEffect: false
  });

  return (
    <Modal
      centered
      radius="lg"
      fullScreen={isMobile}
      classNames={{ content: 'form-modal-content', body: 'form-modal-body' }}
      {...props}
    />
  );
};
